interface IconProps {
  color?: string;
}

export const CheckMarkIcon = ({ color }: IconProps) => (
  <svg viewBox="171.79 160.63 31.19 24.36">
    <path
      id="8228ece246"
      fill={color}
      d="M182.742 184.992q-.151 0-.308-.015a3.26 3.26 0 0 1-2.274-1.254l-7.687-9.953a3.265 3.265 0 0 1 .59-4.579 3.257 3.257 0 0 1 4.574.59l5.558 7.196 14.414-15.57a3.263 3.263 0 0 1 4.32 4.89l-17.023 17.879a3.28 3.28 0 0 1-2.164.816m0 0"
    ></path>
  </svg>
);
